<template>
<EntityReport entity="ReportPPE" />
</template>

<script>
export default {

}
</script>
